import * as sdk from '@cypro/server/sdk'
import {queryOptions, useQuery} from '@tanstack/react-query'

// Which hospital systems this installation is integrated with, decided by the
// server from its env (see /api/health/integrations). Not user-editable.
export const integrationsQueryOptions = queryOptions({
  queryKey: ['health-integrations'],
  queryFn: async () => {
    const response = await sdk.getHealthIntegrations()
    return response.data?.systems ?? []
  },
  // Env-derived config that cannot change while the page is open.
  staleTime: Infinity,
})

export function useGetIntegrations() {
  const {data, ...rest} = useQuery(integrationsQueryOptions)
  return {...rest, systems: data}
}
